/**
 * Lets ui/ components offer "Ask about this" without importing the assistant. The shell
 * registers the handler when the user may use the assistant (core.ai.use).
 */
import { useSyncExternalStore } from 'react';

type AskHandler = (prompt?: string) => void;
let handler: AskHandler | null = null;
const listeners = new Set<() => void>();

export function setAskHandler(fn: AskHandler | null): void {
  handler = fn;
  listeners.forEach((l) => l());
}

export function useAskHandler(): AskHandler | null {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => handler,
    () => handler,
  );
}
